import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "結案",
    isNumber: true,
  },
];

export const HealthCenterYearAndMonthClosedCount = {
  label: "每年/每月結案人數(衛生所)",
  key: "HealthCenterYearAndMonthClosedCount",
  path: "Diabetes/HealthCenterYearAndMonthClosedCount",
  api: "TCS_V_CDM_Count2",
  render: (options) => (
    <Diagram.Diabetes.HealthCenterYearAndMonthClosedCount {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "衛生所",
      field: "衛生所",
      header: "衛生所",
    },
  ],
  levelColumns,
  columns: [],
};
